import { matchPath } from 'react-router-dom';
import { removeLocaleFromUrl } from '@faire/web/common/routing/util';

import { route, PathParameters } from '.';

export const match = (path: string) => {
  return matchPath<PathParameters>(removeLocaleFromUrl(path), route);
};
